export default __webpack_public_path__ + "static/media/undraw_projections_re_ulc6.3a4624af.svg";